import imagesLoaded from 'imagesloaded';

export default function init_object_fit_polyfill() {
    if ('objectFit' in document.documentElement.style) {
        return;
    }

    const images = Array.from(document.querySelectorAll('picture img'));

    for (const image of images) {
        if (! image.classList.contains('is-object-fit-polyfill')) {
            imagesLoaded(image, polyfill.bind(this, image));
        }
    }
}

/**
 *
 * @param {HTMLImageElement} image
 */
function polyfill(image) {
    const style = getComputedStyle(image);

    // The computed style will contain the literal value of unsupported CSS properties under the kebab-case key
    if (style['object-fit'] === 'cover' || style['object-fit'] === 'contain') {
        const src = image.currentSrc ?? image.src;

        Object.assign(image.parentElement.style, {
            backgroundImage: `url(${src})`,
            backgroundSize: style['object-fit'],
            backgroundPosition: style['object-position'] ?? ''
        });

        image.style.visibility = 'hidden';
        image.style.opacity = '0';

        image.classList.add('is-object-fit-polyfill');
    }
}